import type {
  CreateProjectSchema,
  ProjectPriority,
  ProjectPrivacy,
  ProjectStatus,
} from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'

export type CreatePortfolioProjectResponse = {
  id: string
  title: string
  description: string | null
  portfolioColumnId: string
  portfolioId: string
  status: ProjectStatus
  priority: ProjectPriority
  startDate: string | null
  endDate: string | null
  privacy: ProjectPrivacy
  ownerId: string
  responsibleId: string | null
  positionOnColumn: number
  tennantId: string
  createdAt: string
  updatedAt: string
}

export async function createPortfolioProject({
  title,
  description,
  portfolioColumnId,
  portfolioId,
  status,
  priority,
  startDate,
  endDate,
  privacy,
}: CreateProjectSchema): Promise<CreatePortfolioProjectResponse> {
  const { data } = await httpClient.post<CreatePortfolioProjectResponse>(
    '/projects/portfolio-projects',
    {
      title,
      description,
      portfolioColumnId,
      portfolioId,
      status,
      priority,
      startDate,
      endDate,
      privacy,
    },
  )

  return data
}
